/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AssistantSkillRef = {
  /**
   * The pinned version, absent when tracking latest valid.
   */
  pinnedVersionId?: string | undefined;
  /**
   * The currently resolved valid version.
   */
  resolvedVersionId: string;
  /**
   * The attached skill ID.
   */
  skillId: string;
};

/** @internal */
export const AssistantSkillRef$inboundSchema: z.ZodMiniType<
  AssistantSkillRef,
  unknown
> = z.pipe(
  z.object({
    pinned_version_id: z.optional(z.string()),
    resolved_version_id: z.string(),
    skill_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "pinned_version_id": "pinnedVersionId",
      "resolved_version_id": "resolvedVersionId",
      "skill_id": "skillId",
    });
  }),
);

export function assistantSkillRefFromJSON(
  jsonString: string,
): SafeParseResult<AssistantSkillRef, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AssistantSkillRef$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AssistantSkillRef' from JSON`,
  );
}
